(function() {
    angular
        .module('emarket.store')
        .controller('StoreCategoriesMenuController', ['mdPanelRef', 'categories', function(mdPanelRef, categories) {
            var vm = this;
            vm.categories = categories;
            vm.close = function() {
                mdPanelRef.close();
            };
        }]);
}());
